<template>

  <v-container fluid class="promo-bg">
    <section class="combos-grid">
      <v-card v-for="combo in combos" :key="combo.id" class="combo-card promo-card" color="blue-darken-4" elevation="6">
        <!-- BADGE REGALO -->
        <div class="gift-badge">
          En la compra de
        </div>

        <!-- COLLAGE -->
        <!-- COLLAGE -->
        <div class="collage highlight-gift">

          <!-- PRODUCTOS PRINCIPALES (SUMADOS) -->
            <div
              class="main-products"
              :class="{ 'grid-mode': getNormalItems(combo).length > 2 }"
            >
              <div
                v-for="(item, index) in getNormalItems(combo)"
                :key="item.id"
                class="product-wrapper"
                :class="{ 'last': index === getNormalItems(combo).length - 1 }"
              >
                <v-img
                  :src="item.producto.foto"
                  class="collage-img"
                  contain
                />
              </div>
            </div>


          <!-- REGALO (SEPARADO) -->
          <div v-if="getGiftItem(combo)" class="gift-product">
            <div class="gift-label">
              🎁 REGALO
            </div>

            <v-img :src="getGiftItem(combo).producto.foto" class="collage-img gift-main" contain />
          </div>


        </div>


        <!-- NOMBRE -->
        <div class="combo-name">
          {{ combo.nombre }}
        </div>

        <!-- CTA -->
        <div class="combo-actions">
          <v-btn size="small" variant="text" color="white" @click="openDetails(combo)">
            Ver detalles
          </v-btn>

          <v-btn size="small" color="green" class="btn-add-modern pulse" @click="addComboToCart(combo)">
            <v-icon left>mdi-cart-plus</v-icon>
            Agregar
          </v-btn>
        </div>
      </v-card>


    </section>
  </v-container>

  <v-dialog v-model="detailsDialog" max-width="600">
    <v-card>
      <v-card-title class="font-weight-bold">
        {{ selectedCombo?.nombre }}
      </v-card-title>

      <v-card-text>
        <p class="mb-2">{{ selectedCombo?.descripcion }}</p>

        <p class="combo-vigencia">
          <strong>Vigencia:</strong>
          {{ formatDate(selectedCombo?.fecha_inicio) }} —
          {{ selectedCombo?.fecha_fin ? formatDate(selectedCombo?.fecha_fin) : 'Indefinida' }}
        </p>

        <v-divider class="my-3" />

        <!-- LISTA DE PRODUCTOS -->
        <v-card v-for="item in selectedCombo?.items || []" :key="item.id" class="mb-2" variant="outlined">
          <v-row no-gutters>
            <v-col cols="3">
              <v-img :src="item.producto.foto" height="60" contain />
            </v-col>

            <v-col cols="9">
              <div class="pl-2">
                <div class="font-weight-bold">
                  {{ item.producto.nombre }}
                </div>
                <div class="text-caption">
                  Cantidad: {{ item.cantidad }} · Tipo: {{ item.tipo }}
                </div>

                <div v-if="item.precio_fijo === 0" class="text-success font-weight-bold">
                  🎁 Gratis
                </div>
                <div v-else class="text-error font-weight-bold">
                  ${{ item.precio_fijo }}
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="detailsDialog = false">
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>



<style scoped>
.plus-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: 900;
  color: #ffffff;
  background: linear-gradient(135deg, #22c55e, #16a34a);
  border-radius: 50%;
  height: 36px;
  width: 36px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.35);
}
.product-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* DIBUJA EL + */
.product-wrapper::after {
  content: "+";
  position: absolute;
  right: -22px;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 22px;
  font-weight: 900;
  color: #fff;
  background: linear-gradient(135deg, #22c55e, #16a34a);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.35);
  z-index: 2;
}

/* NO mostrar + en el último */
.product-wrapper.last::after {
  display: none;
}
.promo-card {
  position: relative;
  border-radius: 18px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.promo-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);
}

/* BADGE REGALO */
.gift-badge {
  position: absolute;
  top: 12px;
  left: 12px;
  background: linear-gradient(135deg, #22c55e, #16a34a);

  font-weight: 900;
  font-size: 0.75rem;
  padding: 6px 10px;
  border-radius: 10px;
  z-index: 2;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.35);
}

/* COLLAGE */
.collage-img {
  height: 90px;
  width: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent !important;
}

/* REGALO DESTACADO */
.gift-main {
  grid-row: span 2;
  background: #08e700;
  border: 2px solid #ff9800;
  box-shadow: 0 0 12px rgba(255, 152, 0, 0.6);
}

.collage-img {
  border-radius: 12px;
  background: transparent !important;
}

/* CTA */
.combo-name {
  font-weight: 900;
  font-size: 1rem;
  padding: 0 12px;
  color: #034b96;
}

.combo-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px 12px;
  color: black;
}

/* BOTÓN PULSE */
.pulse {
  animation: pulse 1.8s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(31, 255, 84, 0.979);
  }

  70% {
    box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
  }
}
.more-items {
  font-size: 0.85rem;
  font-weight: 900;
  background: transparent !important;
  background: rgba(0,0,0,0.5);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.combo-card {
  padding: 12px;
  border-radius: 16px;
}

.collage {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px;
  background: rgb(253, 161, 24);
  border-radius: 14px;
}

.collage-img {
  width: 80px;
  height: 80px;
  border-radius: 10px;
  background: transparent !important;

  object-fit: contain;
}

.combo-name {
  margin-top: 8px;
  font-weight: 800;
  font-size: 0.95rem;
  color: #ffffff;
}

.combo-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 6px;
}

/* CONTENEDOR PRINCIPALES */
.main-products {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: nowrap;
}

/* CUANDO HAY 3 O MÁS → GRID */
.main-products.grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  max-width: 200px;
}

/* SIGNO + */
.plus-divider {
  font-size: 28px;
  font-weight: 900;
  color: #ffffff;
  background: linear-gradient(135deg, #22c55e, #16a34a);
  border-radius: 50%;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.35);
}

/* REGALO */
.gift-product {
  margin-top: 10px;
  padding-top: 6px;
  border-top: 2px dashed rgba(255, 255, 255, 0.4);
  text-align: center;
}

.gift-label {
  font-size: 0.7rem;
  font-weight: 900;
  color: #fff;
  background: linear-gradient(135deg, #5565f7, #7c3aed);
  display: inline-block;
  padding: 4px 8px;
  border-radius: 8px;
  margin-bottom: 4px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.35);
}

/* REGALO DESTACADO */
.gift-main {
  border: 2px solid #1900ff;
  box-shadow: 0 0 14px rgba(168, 85, 247, 0.6);
}
</style>


<script>
import axios from "axios";
import { inject } from "vue";

export default {
  name: "PromoMulticomboView",

  data() {
    return {
      combos: [],
      detailsDialog: false,
      selectedCombo: null
    };
  },

  setup() {
    // ⭐ Aquí sí funciona inject()
    const cartStore = inject("cartStore");

    return { cartStore };
  },

  methods: {
    getGiftItem(combo) {
      return combo.items.find(
        i => i.tipo?.toLowerCase() === 'regalo' || Number(i.precio_fijo) === 0
      );
    },

    getNormalItems(combo) {
      return combo.items
        .filter(i => i !== this.getGiftItem(combo))
        .slice(0, 3);
    },
    openDetails(combo) {
      this.selectedCombo = combo;
      this.detailsDialog = true;
    },
    async fetchCombos() {
      try {
        const res = await axios.get(
          "https://mvexpress.mx/api/promotions/promos/multicombo",
          {
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json"
            }
          }
        );

        this.combos = res.data.combos ?? [];
      } catch (err) {
        console.error("Error al cargar multicombos:", err);
      }
    },

    addComboToCart(combo) {
      const cartStore = this.cartStore;

      if (!cartStore) throw new Error("cartStore is not provided");

      const addToCart = cartStore.addToCart;
      const validateMultiCombos = cartStore.validateMultiCombos;

      combo.items.forEach(item => {
        for (let i = 0; i < item.cantidad; i++) {
          const isGift = item.tipo?.toLowerCase() === "regalo"; // 🔹 aquí usamos el tipo
          const cartItem = {
            ...item.producto,
            precio: item.precio_fijo,
            price: Number(item.precio_fijo),
            isCombo: true,
            comboId: combo.id,
            isGift
          };

          addToCart(cartItem);

          console.log(`Producto: ${cartItem.nombre}, isGift: ${cartItem.isGift ? "Sí" : "No"}`);
        }
      });

      validateMultiCombos(this.combos);
      //alert("Promoción agregada al carrito ✔");
    }
    ,
    getBannerImage(combo) {
      // 1️⃣ Primero buscamos un producto cuyo tipo sea 'regalo'
      let regalo = combo.items.find(i => i.tipo?.toLowerCase() === "regalo");

      // 2️⃣ Si no hay tipo 'regalo', buscamos un producto con precio fijo 0
      if (!regalo) {
        regalo = combo.items.find(i => Number(i.precio_fijo) === 0);
      }

      // 3️⃣ Retornamos la foto del regalo, o la del primer producto si no hay regalo
      return regalo?.producto?.foto || combo.items[0]?.producto?.foto || "";
    },

    formatDate(dateStr) {
      const options = { year: "numeric", month: "short", day: "numeric" };
      return new Date(dateStr).toLocaleDateString("es-MX", options);
    }
  },

  mounted() {
    this.fetchCombos();
  }
};
</script>
